// This file centralizes the configuration for the frontend application.
// It detects the environment based on the current URL at runtime.

// Detect environment based on current URL
const currentHostname = window.location.hostname;

// Define configurations for each environment
const environments = {
    production: {
        apiUrl: 'https://transit-technologies.ai',
        environment: 'production',
        frontendUrl: 'https://transit-technologies.ai'
    },
    development: {
        apiUrl: 'https://dev.transit-technologies.ai',
        environment: 'development',
        frontendUrl: 'https://dev.transit-technologies.ai'
    },
    local: {
        apiUrl: 'https://localhost:3001',
        environment: 'local',
        frontendUrl: 'http://localhost:3000'
    }
};

// Determine which environment to use based on hostname
let selectedEnv;

if (currentHostname === 'transit-technologies.ai' || currentHostname === 'www.transit-technologies.ai') {
    selectedEnv = environments.production;
} else if (currentHostname === 'dev.transit-technologies.ai') {
    selectedEnv = environments.development;
} else if (currentHostname === 'localhost' || currentHostname === '127.0.0.1') {
    selectedEnv = environments.local;
} else {
    // Fallback for any other hostnames (preview environments, etc.)
    console.warn(`[CLIENT CONFIG] Unknown hostname: ${currentHostname}, defaulting to development`);
    selectedEnv = environments.development;
}

const config = {
    apiUrl: selectedEnv.apiUrl,
    environment: selectedEnv.environment,
    frontendUrl: selectedEnv.frontendUrl
};

export default config;
